// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../css-loader/dist/cjs.js??ref--8-oneOf-1-1!../../../../postcss-loader/src/index.js??ref--8-oneOf-1-2!../../../../stylus-loader/index.js??ref--8-oneOf-1-3!./_avatars.styl");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../vue-style-loader/lib/addStylesClient.js").default
var update = add("2ae77351", content, true, {"sourceMap":false});